export default {
  // Product areas or revenue areas
  areas: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // Rubrics
  rubrics: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // Metrics to apportionment
  metrics: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  metricsPJ: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  metricsArea: {
    loading: false,
    lastUpdate: null,
    data: {}, // colocar loading e lastupdate dentro de cada objeto para cada area
  },
  // Categories to apportionment
  categories: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // DRE para o BPO
  dre: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  valuationOffice: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  valuationProfessional: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  // Dados da margem de comissão
  margin: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  metricsFilial: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  batchCategories: {
    show: false,
    quantity: 0,
    categories_ids: [],
    optionsEdit: [],
  },
}
